import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
export var NumberOfEditSubmissionTime = /*#__PURE__*/function () {
  function NumberOfEditSubmissionTime() {
    _classCallCheck(this, NumberOfEditSubmissionTime);
  }

  _createClass(NumberOfEditSubmissionTime, null, [{
    key: "isValid",
    value: function isValid(value) {
      return value >= this.minTime;
    }
  }]);

  return NumberOfEditSubmissionTime;
}();

_defineProperty(NumberOfEditSubmissionTime, "minTime", 1);

_defineProperty(NumberOfEditSubmissionTime, "unlimitedTime", -1000);